export enum Ecosystem {
  EVM = "evm",
}
